export const impactedTestCasesColumns = [
  {
    key: 'expand',
    showExpand: true,
    headerStyles: {
      
      background: "#7593F2",
      width: '30px'
    }
  },
  {
    display_name: "Testcase Name",
    key: "test_case_name",
    headerStyles: {
      background: "#7593F2",
      
    },
  },
  {
    display_name: "Version",
    key: "fail_ratio",
    headerStyles: {
      
      background: "#7593F2",
    },
    _config: {
      type: 'select',
      value: 'value_1',
      options: [
        {
          label: 'Value 1',
          value: 'value_1'
        },
        {
          label: 'Value 2',
          value: 'value_2'
        }
      ]
    }
  },
  {
    display_name: "Execution Engine",
    key: "summarized_report.core_description",
    headerStyles: {
      
      background: "#7593F2"
    }
  },
  {
    display_name: "Browser",
    key: "summarized_report.resolution",
    headerStyles: {
      
      background: "#7593F2"
    }
  },
  {
    display_name: "",
    key: "context_menu",
    _config: {
      type: 'contextMenuByLevel',
      icon: 'more_horiz',
      options:
        {
          0: [
            {
              label: 'Remove Object',
              value: 'remove_object'
            }
          ],
          1: [
            {
              label: 'Remove Object',
              value: 'remove_object'
            },
            {
              label: 'Remove Object Locator',
              value: 'remove_object_locator'
            }
          ]
        }
    },
    iconStyles: {
      color: 'grey'
    },
    headerStyles: {
      
      background: "#7593F2",
      width: '45px'
    }
  }
];